import React from "react";
import Footer from "../components/Footer";
import TreasureBox from '../assets/treasureBox.png';
import GemA from '../assets/gemA.png';
import MINEICON from '../assets/hammer.png';
import EARNICON from '../assets/earnicon.png';
import DOWNLOADICON from '../assets/downloads.png';
import EXCHANGEICON from '../assets/exchange.png';
import BOOSTICON from '../assets/rocket.png';
import BUTTONICON from '../assets/next.png';
import ANDROIDICON from '../assets/android.png';
import IOSICON from '../assets/ios.png';
import SWAPICON from '../assets/swap.png';
import BALANCEBACKGROUND from '../assets/balanceBackground.png';
import ROCKETBACKGROUND from '../assets/rocketTrans.png';
import EXCHANGEBACKGROUND from '../assets/exchangeTrans.png';
import MODALDOWNLOADICON from '../assets/modalDownload.png';
import MININGICON from '../assets/pick.png';
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../utils/AuthContext";
import { useUser } from '../utils/UserContext';
import { motion } from "framer-motion";
import HomeBackground from '../assets/HomeBackground.jpg';
import ProgressBar from 'react-progressbar';
import styled from "styled-components";
import './Home.css';
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import GemB from '../assets/gemB.png';
import Pickaxe from '../assets/pickaxe.png';
import GEME from '../assets/gemE.png';
import GEMF from '../assets/gemF.png';
import GEMG from '../assets/gemG.png';
import GEMZ from '../assets/gemZ.png';
import LOGO from '../assets/logo.png';


const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    background-color: #060514;
    position: relative;
    min-height: 100vh; /* Important for stretching */
    font-family: Space Grotesk, sans-serif;
`;

const ModalSubTitle = styled.div`
    color: rgba(0, 0, 0, 0.75);
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 20px;
    `

const RadialGradientC = styled.div`
    position: absolute;
    bottom: -100px;
    right: -100px;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;
const RadialGradientD = styled.div`
    position: absolute;
    top: 100px;
    left: -100px;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;

const RadialGradientF = styled.div`
    position: absolute;
    top: 30%;
    right: -100px;
    width: 250px;
    height: 250px;
    background: radial-gradient(circle at center, rgba(255, 193, 7, 0.3), #060514, #060514);
    background-size: cover;
    z-index: 2;
    `;
const RadialGradient = styled.div`
    position: absolute;
    top: -100px;
    right: -100px;
    width: 250px;
    height: 250px;
    background: radial-gradient(circle at center, rgba(255, 193, 7, 0.3), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;

const RadialGradientE = styled.div`
    position: absolute;
    bottom: -100px;
    left: 0px;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle at center, rgba(255, 193, 7, 0.3), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;
const RadialGradientA = styled.div`
    position: absolute;
    top: -100px;
    left: -100px;
    width: 250px;
    height: 250px;
    background: radial-gradient(circle at center, rgba(0, 122, 204, 0.3), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;
const ProgressContainer = styled.div`
    width: 180px;
    height: 180px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 2;
    `
const ProgressMasterContainer = styled.div`
    width: 200px;
    height: 200px;
    border-radius: 50%;
    display: flex;
    margin-top: 20px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 2;
    background-color: rgba(0, 122, 204, 0.05);
    `
const MiningButton = styled.button`
    padding: 10px 20px;
    font-size: 16px;
    background: linear-gradient(to bottom right, #007acc, #007acc, #66b2ff); 
    color: white;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    border: 1px solid #FFC107; 
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    font-family: Space Grotesk, Sans Serif;
    z-index: 2;
    &:hover {
        background-color: #005f99;
    }`
  const CenteredImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  height: 60%;
  z-index: 2;
  pointer-events: none;
`;
const BackGemImage = styled.img`
    position: absolute;
    top: 150px;
    left: 50px;
    z-index: 501;
    `
const BackGemImageA = styled.img`
    position: absolute;
    top: 250px;
    right: 50px;
    z-index: 501;
    `
const BackGemImageB = styled.img`
    position: absolute;
    top: 350px;
    left: 50px;
    z-index: 501;
    `
const BackGemImageC = styled.img`
    position: absolute;
    top: 450px;
    right: 50px;
    z-index: 501;
    `
const BackGemImageD = styled.img`
    position: absolute;
    top: 550px;
    left: 50px;
    z-index: 501;
    `
const BackGemImageE = styled.img`
    position: absolute;
    top: 150px;
    right: 70px;
    z-index: 501;
    `
const BackGemImageF = styled.img`
    position: absolute;
    bottom: 150px;
    right: 70px;
    z-index: 501;
    `
const BackGemImageH = styled.img`
    position: absolute;
    bottom: 210px;
    right: 20px;
    z-index: 501;
    `
const TopRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin: 10px 0px;
    z-index: 2;
    max-width: 90%;
    width: 95%;
    // border-bottom-left-radius: 25px;
    // border-bottom-right-radius: 25px;
    // border: 1px solid rgba(0, 122, 204, 0.5);
    // background-color: rgba(0, 122, 204, 0.25);
`
const TopRowCenterColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: space-around;
    height: 35px;
    position: relative;
    margin-left: 10px;
    `

const UserImageWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
    height: 50px;
    width: 50px;
    margin: 2.5px;
    border-radius: 50%;
    border: 1px solid rgba(0, 122, 204, 0.6);
     `
const UserImage = styled.img`
     width: 100%;
     height: 100%;
     object-fit: cover; 
     border-radius: 50%;
   `;
const UsernameColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-left: 5px;
    `
const BalanceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    position: relative;
    overflow: hidden;
    width: 75%;
    padding: 20px 20px;
    z-index: 500;
    border-radius: 25px;
    border: 1px solid rgba(0, 122, 204, 0.5);
    background-color: rgba(0, 122, 204, 0.05);
    `
const BalanceBackgroundA = styled.img`
    position: absolute;
    right: -5px;
    top: -55px;
    `
const BalanceWrapperRow = styled.div`
     display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 10px;
    `
const ExtraRewardWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    z-index: 500;
    margin-top: 20px;
    margin-bottom: 50px;
    `
const BoxBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: space-between;
    width: 35%;
    position: relative;
    overflow: hidden;
    padding: 20px;
    border-radius: 15px;
    border: 1px solid rgba(0, 122, 204, 0.5);
    background-color: rgba(0, 122, 204, 0.05);
    `
const RocketDiv = styled.img`
    position: absolute;
    right: -65px;
    top: -65px;
    `
const IconWrapper = styled.div`
    width: 35px;
    height: 35px;
    border-radius: 7.5px;
    border: 1px solid rgba(255, 193, 7, 0.5);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    `

const BalanceTitle = styled.div`
    font-size: 18px;
    color: white;
    font-weight: 600;
    `
const BalanceTitleB = styled.div`
    font-size: 16px;
    color: white;
    font-weight: 600;
    margin-top: 10px;
    `
const BalanceTitleA = styled.div`
    font-size: 22px;
    color: white;
    font-weight: 600;
    margin-top: 10px;
    `
const BalanceSubTitle = styled.div`
    font-size: 12px;
    color: rgba(193, 202, 222, 1);
    font-weight: 500;
    `
const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 90%;
    z-index: 500;
    margin-top: 20px;
    `
const ButtonRowColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    `
const ButtonButton = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    cursor: pointer;
    margin-bottom: 5px;
    border-radius: 10px;
    border: 1px solid rgba(255, 193, 7, 0.5);
    background-color: rgba(0, 122, 204, 0.05);   
    `
const ImageShrink = styled.img`
    width: 20px;
    `
const ModalIcon = styled.img`
    margin-top: 20px;
    margin-bottom: 20px;
    `
const GoButton = styled.button`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 105%;
    border: 1px solid transparent;
    background-color: transparent;   
    margin-top: 10px;
    `
const ButtonText = styled.div`
    font-size: 12px;
    color: #c1cade;
    font-weight: 500;
    font-family: space Grotesk;
    margin-right: 5px;
    `

const TopTitle = styled.div`
    color: white;
    font-size: 16px;
    font-weight: 600;
    `
const ModalTopTitle = styled.div`
    color: rgba(0, 0, 0, 0.95);
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
    `
const TopSubTitle = styled.div`
    color: #c1cade;
    font-size: 10px;
    font-weight: 500;
    text-align: center;
    `
const RewardImageContainer = {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '2px solid #007acc',
    borderRadius: '50%',
    padding: '10px',
    marginBottom: '20px',
    };
const RewardImageA = {
    height: '27.5px',
    width: '27.5px',
    objectFit: 'cover',
    
};
const Logo = styled.img`
    position: absolute;
    width: 70%;
    `
const OSRow = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 80%;
    margin-top: 20px;
    `
const OSRowButton = styled.button`
    border: 1px solid #007acc;
    background: #007acc;
    border-radius: 10px;
    width: 100%;
    cursor: pointer;
    padding: 10px 0px;
    font-family: Space Grotesk, Sans Serif;
    color: white;
    font-size: 16px;
    `
const OSRowButtonA = styled.button`
    border: 1px solid rgba(0, 122, 204, 0.25);
    background: rgba(0, 122, 204, 0.25);
    border-radius: 10px;
    width: 100%;
    cursor: pointer;
    padding: 10px 0px;
    font-family: Space Grotesk, Sans Serif;
    color: #060514;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 20px;
    `
const LogoCircle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 150px;
    z-index: 20;
    position: absolute;
    border-radius: 50%;
  `
const LogoCircleA = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 160px;
  z-index: 20;
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(0, 122, 204, 1);
`

const MobileHomePage = () => {

    useEffect(() => {
        if (window.Telegram) {
            window.Telegram.WebApp.expand(); // Only runs inside Telegram
        }
    }, []);
    
    
    const [userInfo, setUserInfo] = useState(null); // User info from Telegram WebApp
    const [authToken, setAuthToken] = useState(null); // Token from server
    const [userData, setUserData] = useState(null); // User data from `/user` endpoint
    const { setUser } = useUser();
    const [error, setError] = useState(null);
    const { login } = useAuth();
    const [isMining, setIsMining] = useState(false);
    const [timerKey, setTimerKey] = useState(0);
    const [countdown, setCountdown] = useState(0);
    const [totalBalance, setTotalBalance] = useState(0);
    const [isMiningModalOpen, setIsMiningModalOpen] = useState(false);
    const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
    const navigate = useNavigate();
    

    const handleMiningModal = () => {
        setIsMiningModalOpen(true);
    };



    const handleMiningButtonPress = async () => {
        startMining();
        handleTimerClick();
        handleMiningModal();
    } 
    
    const checkMiningStatus = () => {
        const startTime = localStorage.getItem('miningStartTime'); // Retrieve from localStorage
        if (startTime) {
            const startTimeDate = new Date(parseInt(startTime, 10));
            const currentTime = new Date();
            const elapsedTime = Math.floor((currentTime - startTimeDate) / 1000); // Elapsed time in seconds
            const remainingTime = 86400 - elapsedTime; // Time left in the 24-hour period
    
            if (remainingTime > 0) {
                setIsMining(true);
                setCountdown(remainingTime);
                setTimerKey((prevKey) => prevKey + 1); // Reset key for timer if needed
            } else {
                localStorage.removeItem('miningStartTime'); // Clear the mining start time
                setIsMining(false);
                setCountdown(86400); // Reset to default
            }
        }
    };

    const formatTime = (timeInSeconds) => {
        const hours = Math.floor(timeInSeconds / 3600);
        const minutes = Math.floor((timeInSeconds % 3600) / 60);
        const seconds = timeInSeconds % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };
    

    const startMining = async () => {
        try {
            const response = await axios.get(`https://chainfree.info:5000/startMining`);
            
        } catch (error) {
            console.error('Error starting mining:', error.message);
        }
    };

    useEffect(() => {
        checkMiningStatus();
    }, []);

    const handleTimerClick = () => {
        if (!isMining) {
            const startTime = new Date().getTime(); // Get the current timestamp
            localStorage.setItem('miningStartTime', startTime.toString()); // Store the timestamp in localStorage
            setIsMining(true); // Set mining state to true
            setCountdown(86400); // Set countdown to 24 hours (in seconds)
            setTimerKey((prevKey) => prevKey + 1); // Update the timer key
        }
    };

    useEffect(() => {
        let timerInterval = null;
    
        if (isMining && countdown > 0) {
            timerInterval = setInterval(() => {
                setCountdown((prevCountdown) => {
                    if (prevCountdown <= 1) {
                        clearInterval(timerInterval); // Stop the timer
                        setIsMining(false); // Set mining state to false
                        localStorage.removeItem('miningStartTime'); // Remove the start time from localStorage
                        return 0; // Reset countdown
                    }
                    return prevCountdown - 1; // Decrease the countdown by 1 second
                });
            }, 1000); // Run every second
        }
    
        return () => {
            if (timerInterval) clearInterval(timerInterval); // Cleanup on component unmount
        };
    }, [countdown, isMining]);
    

 
  
    // Initialize and parse Telegram WebApp initData
    useEffect(() => {
      if (window.Telegram && window.Telegram.WebApp) {
        const initData = window.Telegram.WebApp.initData; // Access initData
        const urlParams = new URLSearchParams(initData); // Parse the query string
  
        const user = JSON.parse(decodeURIComponent(urlParams.get("user"))); // Decode user info
        setUserInfo(user); 
        setUser(user);
      }
    }, []); // Runs once when the component mounts
  
    // Log userInfo when it's updated
    useEffect(() => {
      if (userInfo !== null) {
        console.log("User Info:", userInfo);
      }
    }, [userInfo]);
  
    // Call `/login` on page render to authenticate and get a token
    useEffect(() => {
      const authenticateUser = async () => {
        try {
          if (!userInfo) return;
  
          const response = await axios.post("https://chainfree.info:5000/login", {
            userId: userInfo.id,
            username: userInfo.username,
          });
  
          login(response.data.token, response.data.userData);          
        } catch (error) {
          console.error("Error authenticating user:", error);
        }
      };
  
      authenticateUser(); // Trigger login request
    }, [userInfo]);
  
    // Call `/user` endpoint every 30 seconds with the token
    useEffect(() => {
        fetchUserData();
        const intervalId = setInterval(() => {
            fetchUserData();
        }, 30000);
            return () => clearInterval(intervalId);
        }, []);

    const fetchUserData = async () => {
        try {
            const response = await axios.get(`https://chainfree.info:5000/user`);
            setUserData(response.data.userData);
            setError(null); 
        } catch (error) {
            setError(error.message);
        }
    };

    const combinedBalance = userData 
    ? (userData.balance || 0) + (userData.reward_balance || 0) + (userData.team_rewards || 0)
    : 0;

/////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////// donwload links ////////////////////////////////////////////////////////////

const handleAndroidDownload = async () => {
    setTimeout(() => {
        window.open('https://play.google.com/store/apps/details?id=com.HydrixApp', '_blank');
    }, 500);

}

const handleIosDownload = async () => {
    setTimeout(() => {
        window.open('https://apps.apple.com/us/app/hydrix/id6739980773', '_blank');
    }, 500);

}

//////////////////////////////////////////////////////////////////////////////////////////////////

const goToEarn = () => {
    setTimeout(() => {
        navigate("/earn");
    }, 500); 
}




  

    return (
        <PageContainer>
            <RadialGradient />
            <RadialGradientA />
            <RadialGradientC />
            <RadialGradientD />
            <RadialGradientE />
            
            
            <TopRow>
                <UserImageWrapper>
                {userInfo?.photo_url ? (
                       <UserImage src={userInfo.photo_url} alt="User Avatar" />
                   ) : (
                       <span>🧑</span> 
                   )}   
                </UserImageWrapper>
                <TopRowCenterColumn>
                    <BalanceSubTitle>Hello</BalanceSubTitle>
                    <BalanceTitle>{userInfo ? userInfo.username : "Not available"}</BalanceTitle>
                </TopRowCenterColumn>
            </TopRow>
            <BalanceWrapper>
                <BalanceBackgroundA src={BALANCEBACKGROUND} />
                <BalanceSubTitle>Gem Balance</BalanceSubTitle>
                <BalanceTitleA>{(combinedBalance ?? 0).toFixed(2)}</BalanceTitleA>
                <BalanceWrapperRow>
                    <BalanceSubTitle>Swap Gems</BalanceSubTitle>
                    <img src={SWAPICON} />
                </BalanceWrapperRow>
            </BalanceWrapper>
            <ButtonRow>
                <ButtonRowColumn>
                    <ButtonButton onClick={handleMiningButtonPress} disabled={isMining} style={{ opacity: isMining ? 0.5 : 1, pointerEvents: isMining ? "none" : "auto" }}>
                        <ImageShrink src={MINEICON} />
                    </ButtonButton>
                    <BalanceSubTitle>Mine</BalanceSubTitle>
                </ButtonRowColumn>
                <ButtonRowColumn>
                    <ButtonButton onClick={goToEarn}> 
                        <ImageShrink src={EARNICON} />
                    </ButtonButton>
                    <BalanceSubTitle>Earn</BalanceSubTitle>
                </ButtonRowColumn>
                <ButtonRowColumn>
                    <ButtonButton onClick={() => setIsDownloadModalOpen(true)}>
                        <ImageShrink src={DOWNLOADICON} />
                    </ButtonButton>
                    <BalanceSubTitle>Download</BalanceSubTitle>
                </ButtonRowColumn>
            </ButtonRow>
            <ProgressMasterContainer>
                <ProgressContainer>
                    <CircularProgressbar
                        value={(1 - countdown / 86400) * 100}
                        strokeWidth={4}
                        circleRatio={1}
                        styles={buildStyles({
                            pathColor: "#FFC107",
                            trailColor: "rgba(0, 122, 204, 0.15)",
                        
                        })}
                    />
                    <LogoCircle>
                        {!isMining ? (
                            <Logo src={LOGO} />
                        ) : (
                            <ButtonRowColumn>
                                <BalanceTitle>{formatTime(countdown)}</BalanceTitle>
                                <BalanceSubTitle>Time Remaining</BalanceSubTitle>
                            </ButtonRowColumn>
                        )}
                    </LogoCircle>
                    <LogoCircleA />
                </ProgressContainer>
            </ProgressMasterContainer>
            <ExtraRewardWrapper>
                <BoxBox>
                    <RocketDiv src={EXCHANGEBACKGROUND} />
                    <IconWrapper>
                        <img src={EXCHANGEICON} />
                    </IconWrapper>
                        <BalanceTitleB>Exchange</BalanceTitleB>
                        <GoButton>
                            <ButtonText>Coming soon</ButtonText>
                            <img src={BUTTONICON} />
                        </GoButton>
                </BoxBox>
                <BoxBox>
                    <RocketDiv src={ROCKETBACKGROUND} />
                    <IconWrapper>
                        <img src={BOOSTICON} />
                    </IconWrapper>
                    <BalanceTitleB>Boost</BalanceTitleB>
                    <GoButton>
                        <ButtonText>Coming soon</ButtonText>
                        <img src={BUTTONICON} />
                    </GoButton>
                </BoxBox>
            </ExtraRewardWrapper>
            
        
            
        
      
{isMiningModalOpen && (
    <motion.div 
        initial={{ y: "100%" }} 
        animate={{ y: "0%" }} 
        transition={{ duration: 0.5, ease: "easeInOut" }}
        style={{
            position: "fixed",
            top: "25%",
            width: "80%",
            background: "#eee",
            borderRadius: "10px",
            boxShadow: "0 -4px 10px rgba(0, 0, 0, 0.2)",
            display: "flex",
            flexDirection: 'column',
            alignItems: "center",
            justifyContent: "center",
            zIndex: "999",
        }}
        onClick={() => setIsMiningModalOpen(false)}
    >
        <ModalIcon src={MININGICON} />
        <ModalTopTitle>Excellent!</ModalTopTitle>
        <ModalSubTitle style={{ width: '80%' }}>You are now Mining Gems!</ModalSubTitle>
        <ModalSubTitle style={{ width: '80%' }}>Check back in 24 hours to mine again!</ModalSubTitle>
        
    </motion.div>
)}

{isDownloadModalOpen && (
    <motion.div 
        initial={{ y: "100%" }} 
        animate={{ y: "0%" }} 
        transition={{ duration: 0.5, ease: "easeInOut" }}
        style={{
            position: "fixed",
            top: "25%",
            width: "80%",
            height: "auto",
            background: "#eee",
            borderRadius: "10px",
            boxShadow: "0 -4px 10px rgba(0, 0, 0, 0.2)",
            display: "flex",
            flexDirection: 'column',
            alignItems: "center",
            justifyContent: "center",
            zIndex: "999",
        }}
        onClick={() => setIsDownloadModalOpen(false)}
    >
        <ModalIcon src={MODALDOWNLOADICON} />
        <ModalTopTitle>Choose Your Device</ModalTopTitle>
        <OSRow>
            <OSRowButton onClick={handleAndroidDownload}>
                Android
            </OSRowButton>
            <OSRowButtonA onClick={handleIosDownload}>
                ios
            </OSRowButtonA>
        </OSRow>
        
    </motion.div>
)}
      
      <Footer />

    </PageContainer>
    );
};

export default MobileHomePage;